
import React from 'react';
import { TableCell, TableRow } from "@/components/ui/table";
import { formatCurrency } from '@/components/borrowings/debt/utils';
import { TimeHorizon } from '../index';

interface ALMPositionTableRowProps {
  item: { name: string; values: Record<string, number> };
  currentHorizons: TimeHorizon[];
  isHeader?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const ALMPositionTableRow = ({ 
  item, 
  currentHorizons, 
  isHeader = false,
  className = "", 
  children 
}: ALMPositionTableRowProps) => {
  return (
    <TableRow className={className}>
      <TableCell className={isHeader ? "" : "pl-6 text-muted-foreground"}>
        {item.name}
      </TableCell>
      {currentHorizons.map(horizon => (
        <TableCell 
          key={horizon.id} 
          className={`text-right ${isHeader ? "" : "text-muted-foreground"}`}
        >
          {formatCurrency(item.values[horizon.id] || 0)}
        </TableCell>
      ))}
      {children}
    </TableRow>
  );
};

export default ALMPositionTableRow;
